import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, HomeIcon } from 'lucide-react';
import { IMAGES } from '../data/site';
const ease = [0.22, 1, 0.36, 1] as const;
export function Hero() {
  return <section id="inicio" className="relative min-h-[100svh] w-full overflow-hidden bg-ink" data-id="element-166" data-mp="9lv1krql6hwd">
      <motion.img src={IMAGES.hero} alt="Ambiente moderno equipado con muebles y electrodomésticos de alta gama" className="absolute inset-0 h-full w-full object-cover" initial={{
      scale: 1.12
    }} animate={{
      scale: 1
    }} transition={{
      duration: 2.2,
      ease
    }} data-id="element-167" data-mp="4mi4zf9wxwgl" />
      <div className="absolute inset-0 bg-ink/60" aria-hidden="true" data-id="element-168" data-mp="sa9nj0m1r5qb" />
      <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-ink/80 to-transparent" aria-hidden="true" data-id="element-169" data-mp="ncq13df73mna" />

      <div className="relative mx-auto flex min-h-[100svh] max-w-7xl flex-col justify-center px-5 sm:px-8 pt-32 pb-24 lg:pb-32" data-id="element-170" data-mp="3d33fj0i70xlt">
        <div className="max-w-3xl" data-id="element-171" data-mp="384s5aonzkl32">
          <motion.span initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.15,
          ease
        }} className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-2 text-xs sm:text-sm font-medium tracking-wide text-white backdrop-blur-md" data-id="element-172" data-mp="3j897ze322dq2">
            <span className="h-1.5 w-1.5 rounded-full bg-brand" aria-hidden="true" data-id="element-173" data-mp="30i19j9aawbg7" />
            Muebles y electrodomésticos desde 2021
          </motion.span>

          <motion.h1 initial={{
          opacity: 0,
          y: 28
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.9,
          delay: 0.25,
          ease
        }} className="mt-7 text-4xl sm:text-6xl lg:text-7xl font-semibold leading-[1.05] tracking-tight text-white" data-id="element-174" data-mp="35aax4iny0zfb">
            Equipamos hogares,
            <br data-id="element-175" data-mp="2lkqzm4db3dml" />
            <span className="text-brand" data-id="element-176" data-mp="2lkij82hz5q6n">construimos bienestar.</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.9,
          delay: 0.4,
          ease
        }} className="mt-7 max-w-2xl text-base sm:text-lg lg:text-xl leading-relaxed text-white/80" data-id="element-177" data-mp="s1rqqjt21ys6">
            5 años acompañando a miles de familias con muebles y electrodomésticos de calidad,
            atención personalizada y un servicio pensado para durar.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.9,
          delay: 0.55,
          ease
        }} className="mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4" data-id="element-178" data-mp="1ayt9d7fj7xel">
            <a href="#quienes-somos" className="group inline-flex items-center justify-center gap-2 rounded-full bg-brand px-7 py-4 text-sm sm:text-base font-medium text-white transition-all duration-300 hover:bg-brand-dark hover:shadow-float focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-ink" data-id="element-179" data-mp="x1w7maxvkvix">
              Conocé nuestra historia
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-id="element-180" data-mp="218tpdugn58ec" />
            </a>
            <a href="#contacto" className="inline-flex items-center justify-center rounded-full border border-white/35 bg-white/5 px-7 py-4 text-sm sm:text-base font-medium text-white backdrop-blur-md transition-all duration-300 hover:bg-white hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-ink" data-id="element-181" data-mp="2b20tlbznaicu">
              Contactanos
            </a>
          </motion.div>
        </div>

        <motion.aside initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.75,
        ease
      }} className="mt-14 lg:mt-0 lg:absolute lg:bottom-32 lg:right-8 w-full max-w-sm rounded-3xl border border-white/20 bg-white/10 p-6 sm:p-7 backdrop-blur-xl shadow-float" data-id="element-182" data-mp="uokd5m63lp5q">
          <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-brand text-white" data-id="element-183" data-mp="e9ts7v09a53x">
            <HomeIcon className="h-5 w-5" strokeWidth={1.5} aria-hidden="true" data-id="element-184" data-mp="9bidb5v3t4eu" />
          </span>
          <p className="mt-5 text-xl sm:text-2xl font-medium leading-snug text-white" data-id="element-185" data-mp="3hrbwjsgtktzl">
            “No vendemos muebles. Creamos hogares.”
          </p>
          <p className="mt-3 text-sm text-white/65" data-id="element-186" data-mp="3rg3k7oeuks4p">Nuestra forma de entender el trabajo.</p>
        </motion.aside>
      </div>
    </section>;
}